import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { ApplicationService } from '../../../../services/application.service.js';
import { style } from './phone.style.js';
import './refi-text-opt-in/refi-text-opt-in.component.js';
import { globalStyle } from '../../../../global-styles.style.js';
import '@cof/fs-phone-number-field-wc/fs-phone-number-field.js';
import { stratum } from '../../../../../constants/stratum.js';

class RefiPersonalPhoneComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepCommunication');
    this.values = {};
    this.coAppPrefix = '';
    this.phoneId = '';
    this.textOptIn = false;

    this.touchedField = false;
  }

  static styles = [style, globalStyle];

  static properties = {
    applicant: { type: Object, reflect: true },
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
    textOptIn: { type: Boolean, attribute: 'text-opt-in' },
    phoneNumber: { type: String, reflect: true },
    optInChildId: { type: String, attribute: 'opt-in-child-id', reflect: true },
  };

  connectedCallback() {
    super.connectedCallback();
    this.coAppPrefix = this.isPrimary ? '' : 'co-';
    this.phoneId = `${this.coAppPrefix}phone`;
    this.application = ApplicationService.Application;
    this.values = {
      phoneNumber: this.isPrimary
        ? this.application.primaryApplicant.phoneNumber
        : this.application.coApplicant.phoneNumber,
    };
  }

  resetValues() {
    this.application = ApplicationService.Application;
    this.values = {
      phoneNumber: this.isPrimary
        ? this.application.primaryApplicant.phoneNumber
        : this.application.coApplicant.phoneNumber,
    };
    // Ensure DOM is settled before grabbing the element
    setTimeout(() => {
      const phoneField = this.shadowRoot.getElementById(this.phoneId);
      phoneField.setAttribute('value', this.values.phoneNumber);
      this.touchedField = false;

      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: 'phoneNumber',
            isValid: phoneField.validity.valid && phoneField.value !== '',
          },
        })
      );
      this.requestUpdate();
    }, 0);
  }

  render() {
    return html`
      <div>
        ${!this.textOptIn
          ? html` <div class="personal__phone">
              <fs-phone-number-field
                id="${this.phoneId}"
                autocomplete="tel"
                name="phone"
                type="tel"
                value-missing-message="Please enter a valid phone number"
                maxLength="14"
                pattern="^([2-9]\\d{2})-?[2-9]\\d{2}-?\\d{4}$"
                required
                helper-text="${ApplicationService.isIconicV2 &&
                (!this.values.phoneNumber || this.touchedField)
                  ? 'I agree to receive autodialed, artificial, and/or prerecorded calls, texts, and voicemails from Capital One at this number. These calls and messages will be about my relationship with Capital One, including the handling, servicing, and billing of any account. Message and data rates may apply.'
                  : ''}"
                @change="${(ev) => {
                  this.touchedField = true;

                  if (ev.target.value.startsWith('1-')) {
                    ev.target.value = ev.target.value.slice(2);
                  }
                  this.changed('phoneNumber', ev);
                }}"
                @blur="${(ev) => {
                  this.changed('phoneNumber', ev);
                  this.phoneNumber = ev.target.value;
                  if (ev.target.validity.valid) {
                    stratum.publishTag(
                      TagKey.PQ_TEXT_INPUT_FIELD_EDITED_FIELD,
                      { replacements: { value: this.phoneId } }
                    );
                  } else {
                    stratum.publishTag(
                      TagKey.PQ_TEXT_INPUT_FIELD_FIELD_VALIDATION_ERROR_MESSAGE,
                      {
                        replacements: {
                          value:
                            'Please enter a valid phone number XXX-XXX-XXXX or XXXXXXXXXX',
                        },
                      }
                    );
                  }
                }}"
                value="${this.values.phoneNumber}"
                pattern-mismatch-message="Please enter a valid phone number XXX-XXX-XXXX or XXXXXXXXXX"
              >
                Phone number
              </fs-phone-number-field>
            </div>`
          : html`
              <refi-text-opt-in
                id="${this.optInChildId}"
                class="personal__text-opt-in"
                prefix="${this.coAppPrefix}"
                ?is-primary="${this.isPrimary}"
                phone-number="${this.values.phoneNumber}"
              ></refi-text-opt-in>
            `}
      </div>
    `;
  }

  firstUpdated() {
    if (!this.textOptIn) {
      const phoneField = this.shadowRoot.getElementById(this.phoneId);
      this.dispatchEvent(
        new CustomEvent('validity', {
          detail: {
            name: 'phoneNumber',
            isValid: phoneField.validity.valid && phoneField.value !== '',
          },
        })
      );
    }
  }

  changed(name, ev) {
    if (ev.target.validity.valid) {
      this.values[name] = ev.target.value.trim();
    }
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: { name, isValid: ev.target.validity.valid },
      })
    );
  }
}

customElements.define('refi-personal-phone', RefiPersonalPhoneComponent);
